import React, { FC } from "react";
import NcdcRequestProgress from "./NcdcRequestProgress";
import classNames from "classnames";
import {useForm} from "react-hook-form";

type Props = {
    page: number;
    getPage: (seq: number) => void;
    getData: (data: any) => void;
}

const NcdcRequestPeriod: FC<Props> = ({page, getPage, getData}) => {
    const goToPrev = () => {
        window.scrollTo(0, 0);
        getPage(page - 1);
    }

    const goToNext = () => {
        window.scrollTo(0, 0);
        getPage(page + 1);
    }

    const { register, handleSubmit } = useForm();
    const onSubmit = (data: any) => {
        window.scrollTo(0, 0);
        getPage(page + 1);
        getData(data);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>

        <div className={classNames('ncdc-request-form-wrapper', {'no-show': page !== 2})}>
            <div className={'ncdc-request-form'}>
                <div className={'common-form-header-wrapper'}>
                    <span className={'common-form-header-title'}>데이터 신청</span>
                    <div className={'common-form-header-circle'} />
                </div>
                <NcdcRequestProgress seq={page - 1} />
                <div className={'common-form-table-wrapper'}>
                    <div className={'common-form-table'}>
                        <div className={'common-form-table-header-wrapper'}>
                            <div className={'common-form-table-header-title'}>
                                필요 서류 제출
                            </div>
                            <div className={'common-form-table-header-alert'}>
                                * 필수사항입니다.
                            </div>
                        </div>
                        <div className={'common-form-table-body-wrapper'}>
                            <div className={'common-form-table-body'}>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        IRB 승인 번호
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text lg'}  {...register("irbNo")} />
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        승인기관
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text lg'} />
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        IRB 연구계획서
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text lg'} />
                                    <button className={'common-button light md ml-5'}>찾아보기</button>
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        IRB 결과통지서
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text lg'} />
                                    <button className={'common-button light md ml-5'}>찾아보기</button>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'common-form-table-wrapper'}>
                    <div className={'common-form-table'}>
                        <div className={'common-form-table-header-wrapper'}>
                            <div className={'common-form-table-header-title'}>
                                분석공간 이용료 견적
                            </div>
                            <div className={'common-form-table-header-desc'}>
                                ※ 데이터 제공 비용은 데이터 구축 후 마이페이지를 통해 확인 가능합니다.
                            </div>
                        </div>
                        <div className={'common-form-table-body-wrapper'}>
                            <div className={'common-form-table-body'}>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        분석도구 선택
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input type={'checkbox'} /> R
                                    <input type={'checkbox'} className={'ml-10'} /> Python
                                    <input type={'checkbox'} className={'ml-10'} /> SAS
                                    <input type={'checkbox'} className={'ml-10'} /> STATA
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        사용 기간
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input type={'number'} className={'common-form-input-text xs'} />
                                    <span className={'common-form-input-plain-text ml-10'}>
                                        개월 X 700,000
                                        <span> X 0.5</span>
                                        <span className={'common-form-input-plain-text alert'}> (50% 할인 적용)</span>
                                    </span>
                                    <span className={'ml-30'}>=</span>
                                    <input className={'common-form-input-text md ml-10'} />
                                    <span className={'ml-10'}>원</span>
                                </label>
                                <label>
                                    <span className={'common-form-input-label'} />
                                    <input type={'number'} className={'common-form-input-text xs'} />
                                    <span className={'common-form-input-plain-text ml-10'}>
                                        개월 X 224,000
                                        <span> X 0.5</span>
                                        <span className={'common-form-input-plain-text alert'}> (50% 할인 적용)</span>
                                    </span>
                                    <span className={'ml-30'}>=</span>
                                    <input className={'common-form-input-text md ml-10'} />
                                    <span className={'ml-10'}>원</span>
                                </label>
                                <label>
                                    <span className={'common-form-input-label'} />
                                    <input type={'number'} className={'common-form-input-text xs'} />
                                    <span className={'common-form-input-plain-text ml-10'}>
                                        개월 X 50,000&nbsp;&nbsp;
                                        <span> X 0.5</span>
                                        <span className={'common-form-input-plain-text alert'}> (50% 할인 적용)</span>
                                    </span>
                                    <span className={'ml-30'}>=</span>
                                    <input className={'common-form-input-text md ml-10'} />
                                    <span className={'ml-10'}>원</span>
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        예상 비용
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text lg'} />
                                    <span className={'ml-10'}>원</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'common-form-table-wrapper'}>
                    <div className={'common-form-table'}>
                        <div className={'common-form-table-header-wrapper'}>
                            <div className={'common-form-table-header-title'}>
                                분석포털 이용료 견적
                            </div>
                            <div className={'common-form-table-header-desc'}>
                                ※ 데이터 제공 비용은 데이터 구축 후 마이페이지를 통해 확인 가능합니다.
                            </div>
                        </div>
                        <div className={'common-form-table-body-wrapper'}>
                            <div className={'common-form-table-body'}>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        분석도구 선택
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input type={'checkbox'} /> R
                                    <input type={'checkbox'} className={'ml-10'} /> Python
                                    <input type={'checkbox'} className={'ml-10'} /> SAS
                                    <input type={'checkbox'} className={'ml-10'} /> STATA
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        사용 기간
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input type={'number'} className={'common-form-input-text xs'} />
                                    <span className={'common-form-input-plain-text ml-10'}>
                                        개월 X 700,000
                                        <span> X 0.5</span>
                                        <span className={'common-form-input-plain-text alert'}> (50% 할인 적용)</span>
                                    </span>
                                    <span className={'ml-30'}>=</span>
                                    <input className={'common-form-input-text md ml-10'} />
                                    <span className={'ml-10'}>원</span>
                                </label>
                                <label>
                                    <span className={'common-form-input-label'} />
                                    <input type={'number'} className={'common-form-input-text xs'} />
                                    <span className={'common-form-input-plain-text ml-10'}>
                                        개월 X 224,000
                                        <span> X 0.5</span>
                                        <span className={'common-form-input-plain-text alert'}> (50% 할인 적용)</span>
                                    </span>
                                    <span className={'ml-30'}>=</span>
                                    <input className={'common-form-input-text md ml-10'} />
                                    <span className={'ml-10'}>원</span>
                                </label>
                                <label>
                                    <span className={'common-form-input-label'} />
                                    <input type={'number'} className={'common-form-input-text xs'} />
                                    <span className={'common-form-input-plain-text ml-10'}>
                                        개월 X 50,000&nbsp;&nbsp;
                                        <span> X 0.5</span>
                                        <span className={'common-form-input-plain-text alert'}> (50% 할인 적용)</span>
                                    </span>
                                    <span className={'ml-30'}>=</span>
                                    <input className={'common-form-input-text md ml-10'} />
                                    <span className={'ml-10'}>원</span>
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        예상 비용
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text lg'} />
                                    <span className={'ml-10'}>원</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'common-form-button-wrapper'}>
                    <div>
                        <button className={'common-button light'} onClick={goToPrev}>이전</button>
                    </div>
                    <div>
                        <button className={'common-button light'}>임시저장</button>
                        <button className={'common-button primary ml-10'} type="submit">다음</button>
                    </div>
                </div>
            </div>
        </div>
        </form>
    );
}

export default NcdcRequestPeriod;
